module.exports = __webpack_public_path__ + "img/28497030000174.0ec0771a.png";